export type Locale = 'en' | 'da';

const da = {
  common: {
    from: 'Fra',
    before: 'Før',
    ticket: 'Billet',
    ticket_plural: 'Billetter',
    edit: 'Rediger',
    pcs: 'stk.',
    discount: 'Rabat',
    transaction_fee: 'Transaktionsgebyr',
    back: 'Tilbage',
    back_to_overview: 'Tilbage til oversigt',
    continue: 'Fortsæt',
    fee: 'Billetgebyr',
    total: 'Total',
    vat: 'Moms udgør',
    decrease: 'Sænk',
    increase: 'Forøg',
    days: 'dage',
    show_more: 'Vis mere',
    show_less: 'Vis mindre',
    see_all: 'Se alle',
    see_category: 'Se kategori',
    close: 'Luk',
    next: 'Næste',
    prev: 'Forrige',
    soldout: 'Udsolgt',
    few_tickets: 'Få billetter tilbage',
    remove: 'Fjern',
    cart_emptied_toast: 'Tiden til at placere din ordre er udløbet. Du har 10 minutter til at fuldføre en ordre.',
  },
  checkout: {
    addons: 'Tilvalg',
    tickets: 'Billetter',
    information: 'Kundeoplysninger',
    choose_tickets: 'Vælg billetter',
    choose_seats: 'Vælg pladser',
    redeem: 'Indløs',
    discount_code: 'Rabatkode',
    redeem_discount_code: 'Indløs rabatkode',
    vouchercode_removed: '{voucher_code_description} fjernet',
    redeem_gift_card: 'Indløs gavekort',
    gift_card: 'Gavekortkode',
    type: 'Indtast',
    download_your_tickets: 'Hent dine billetter',
    loading_pdf: 'Vent venligst...',
    download_tickets: 'Hent billetter',
    download_tickets_as_pdf: 'Download billetter som PDF',
    your_tickets_are_also_sent_to: 'Dine billetter er også sendt til:',
    show_info: 'Vis info',
    ticket_info: 'Billetinfo',
    leave_checkout: 'Forlad checkout',
    leave_checkout_header: 'Du er ved at forlade checkout',
    leave_checkout_header_expired: 'Tiden er udløbet for checkout',
    leave_checkout_confirmation: 'Du vil miste dine billetter hvis du forlader checkout.',
    leave_checkout_confirmation_expired: 'Tiden til at placere din ordre er udløbet.',
    leave_checkout_continue: 'Du kan lægge dine billetter i kurv, og købe flere billetter.',
    leave_checkout_leaving_payment: 'Hvis du forlader checkout nu, vil din betaling blive afbrudt og du må genbestille.',
    stay_in_checkout: 'Bliv i checkout',
    stay_in_checkout_cancel: 'Annuller',
    reservation_mismatch: 'Antallet af billetter kan ikke opnåes. Kurven er opdateret med det antal billetter som er muligt.',
    reservation_mismatch_event_max_tickets: 'Max {count} {tickets} kan bestilles for dette event.',
    reservation_mismatch_available: 'Kun {count} {tickets} er tilgængelige for denne billettype.',
    reservation_mismatch_ticket_max_tickets: 'Max {count} {tickets} kan bestilles for denne billettype.',
    reservation_mismatch_ticket_min_tickets: 'Du skal bestille mindst {count} {tickets} for denne billettype.',
    leave: 'Forlad',
    payment: 'Betaling',
    choose_payment_method: 'Vælg betalingsmetode',
    countdown: 'tilbage til at udføre ordren',
    receipt: 'Kvittering',
    organizer: 'Arrangør',
    order_information: 'Ordre information',
    order_number: 'Ordrenummer',
    order_time: 'Tidspunkt for køb',
    transaction_id: 'Transaktions ID',
    card_number: 'Kortnummer',
    add_to_calendar: 'Tilføj til kalender',
    download_ics: 'Download ICS',
    order_summary: 'Ordreopsummering',
    continue_to_payment: 'Fortsæt til betaling',
    continue_to_payment_window: 'Fortsæt til betalingsvinduet',
    cancel_order: 'Annuller ordre',
    add_to_basket_and_continue: 'Læg i kurv og shop mere',
    add_info_to: 'Tilføj info til {name}',
    order_confirmation_will_be_sent_to:
      'Din ordrebekræftelse bliver sendt hertil',
    email_placeholder: 'E-mail',
    repeat_email_placeholder: 'Gentag e-mail',
    name_placeholder: 'For- og efternavn',
    address_placeholder: 'Adresse',
    zip_placeholder: 'Post nr.',
    city_placeholder: 'By',
    country_placeholder: 'Land',
    phone_placeholder: 'Telefonnummer',
    terms_label: 'Jeg accepterer salgs- og leveringsbetingelser',
    terms_label_prefix: 'Jeg accepterer ',
    terms_label_link: 'salgs- og leveringsbetingelser',
    terms_label_header: 'Salgs- og leveringsbetingelser',
    newsletter_label: 'Ja tak, tilmeld mig {organizer} nyhedsbrev',
    seats: 'Pladser',
    see_seats: 'Se dine pladser ({selected} / {total} valgte)',
    your_seats: 'Dine pladser',
    extra_tickets_shown: 'Der vises nu {count} billetter med koden:',
    extra_ticket_shown: 'Der vises nu 1 billet med koden:',
    tickets_recievement_notice:
      'Du modtager din billet pr. e-mail og skal medbringe den digitalt eller selv printe den ud.',
    thanks_for_your_order: 'Tak for din bestilling',
    ticket_buying_title: 'Billetkøb info',
    ticket_buying_notice:
      'Dine billetter er betalt. Du kan hente dem her på siden.',
    tickets_sent_to_email:
      'Vi har samtidig fremsendt dine billetter til din e-mailadresse: {email}',
    tickets_entry_notice:
      'Arrangøren kan bede dig om at fremvise din billet ved indgangen. Kontrollér derfor venligst billetten for arrangement, dato, tidspunkt m.v. Det er vigtigt, at din billet er i hel og læselig tilstand, når du ankommer til arrangementet. En billet og den unikke stregkode giver adgang for én person. Det er ulovligt at kopiere billetter.',
    tickets_bank_statement:
      'Billetkøbet vil fremgå som et køb hos Safeticket på dit kontoudtog.',
    tickets_law_notice:
      'Bemærk: I henhold til "Lov om forbrugeraftaler § 18 stk. 12" er køb af billetter ikke omfattet af fortrydelsesretten.',
    tickets_see_terms:
      'Se også ',
    tickets_see_terms_link: 'salgs- og leveringsbetingelserne.',
    questions: 'Har du spørgsmål?',
    questions_can_be_sent_to:
      'Spørgsmål kan rettes til <a href="mailto:{email}"> {email}</a> eller <a href="tel:{phone}">{phone}</a>.',
    questions_order_number:
      'Oplys venligst ordrenummer ved eventuelt henvendelse til Safeticket A/S.',
    customfield_group_header_event: '',
    customfield_group_header_tickettype: 'Generelt for tilmelding',
    customfield_group_header_ticket: '{group} Tilmelding',
  },
  event: {
    events: 'Arrangementer',
    play_video: 'Afspil video',
    go_to_slide: 'Gå til slide {slide}',
    open_in_google_maps: 'Åbn i Google Maps',
    location: 'Lokation',
    find_tickets: 'Find billetter',
    x_tickets_left: '{count} billetter tilbage',
    time: 'Tidspunkt',
    related_events: 'Relaterede arrangementer',
    categories: 'Kategorier',
    organizer: 'Arrangør',
    remarks: 'Bemærkning',
    photo_video_social_media: 'Foto, video og sociale medier',
    photo_video: 'Foto og Video',
    photo_video_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    social_media: 'Sociale medier',
    social_media_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    ends_in: 'Slutter om',
    starts_in: 'Starter om',
    sold_out: 'Udsolgt',
    sale_not_started: 'Billetsalg ikke startet endnu',
    sale_not_started_with_date: 'Billetsalg starter {date}',
    sale_ended: 'Billetsalget er slut',
  },
  validation: {
    number: 'Dette felt skal være et tal',
    email: 'Indtast venligst en gyldig e-mailadresse',
    emails_must_match: 'E-mailadresserne skal matche',
    phone: 'Indtast venligst et gyldigt telefonnummer',
    cpr: 'Indtast venligst et gyldigt CPR-nummer',
    required: 'Dette felt er påkrævet',
    zip: 'Indtast venligst et gyldigt postnummer',
    terms: 'Du skal acceptere salgs- og leveringsbetingelserne',
    order_number: 'Indtast venligst et gyldigt ordrenummer',
    char_limit: 'Maksimalt {limit} tegn tilladt',
    invalid_option: 'Indtast venligst en gyldig værdi',
  },
  globals: {
    change_language: 'Skift sprog',
    categories: 'Kategorier',
    locations: 'Lokationer',
    date: 'Dato',
    search: 'Søg',
    search_placeholder: 'Søg efter event...',
    cart: 'Kurv',
    continue_to_checkout: 'Fortsæt til bestilling',
    login: 'Login',
    cart_empty: 'Din kurv er tom',
    check_gift_card: 'Tjek gavekort',
    cancel_tickets: 'Annuller billetter',
    transfer_voucher: 'Overfør klip',
    organizer_login: 'Arrangør login',
    ticket_buyer: 'Billetkøber',
    resend_tickets: 'Mistet din billet?',
    contact: 'Kontakt',
    terms: 'Betingelser',
    cookies: 'Cookies',
    cta_title: 'Afholder du events? Få et billet- og tilmeldingssystem',
    cta_unique_selling_point_low_fee: 'Blandt Danmarks billigste', 
    cta_unique_selling_point_support: 'Fri dansk support',
    cta_button_text: 'Se mere',
    choose: 'Vælg',
    no_results: 'Intet resultat. Prøv igen.',
    see_all_events: 'Se alle events',
  },
  date: {
    january: 'Januar',
    february: 'Februar',
    march: 'Marts',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December',
    mon: 'Man',
    tue: 'Tir',
    wed: 'Ons',
    thu: 'Tor',
    fri: 'Fre',
    sat: 'Lør',
    sun: 'Søn',
  },
  not_found: {
    title: 'Siden ikke fundet',
    message: 'Beklager, den side du leder efter findes ikke.',
    back_to_home: 'Tilbage til forsiden',
  },
  terms: {
    head_title: 'Betingelser',
    organizer: 'Arrangøren',
    sales_delivery_terms: 'Salgs og leveringsbetingelser',
    contact_person: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-mail',
    vat: 'CVR',
    applicable_for: 'Følgende betingelser er gældende for',
    hereafter_referred: 'Herefter benævnt',
    general: 'GENERELT',
    general_clause_1: 'Enhver leverance mellem parterne finder sted på grundlag af nærværende almindelige salgs- og leveringsbetingelser.',
    general_clause_2: 'formidler udelukkende salg af billetter mellem billetkøberen og den ansvarlige arrangør.',
    payment: 'BETALING',
    payment_clause_1: 'Der kan betales med Dankort, Visa/Dankort, Visa, MasterCard samt VisaElectron.',
    payment_clause_2: 'Betaling skal finde sted ved onlinebetaling.',
    payment_clause_3: 'Din betaling hæves fra dit betalingskort når billetten er afsendt.',
    delivery: 'LEVERING OG FORSINKELSE',
    delivery_clause_1: 'Levering sker enten via direkte download samt elektronisk post i form af en PDF-fil (PrintSelv) straks efter betaling, eller ved valg af postforsendelse, fremsendt med PostDanmark som almindelig brevpost næste hverdag. Pengene hæves på dit betalingskort når billetten afsendes.',
    delivery_clause_2: 'I tilfælde af bortkomst kan erstatningsbilletter fremsendes, hvorved de oprindelige billetter automatisk annulleres.',
    privacy: 'BEHANDLING AF PERSONOPLYSNINGER',
    privacy_clause_1: 'Du accepterer som kunde at {name} opbevarer de af dig afgivne personoplysninger i forbindelse med billetkøb.',
    privacy_clause_2: '{name} overdrager informationer såsom navn, adresse, telefonnummer og e-mail til den arrangør, der afholder det pågældende arrangement du som kunde har købt billet til.',
    privacy_clause_3: 'Dette sker med henblik på, at arrangøren kan yde den optimale kundeservice, f.eks. i tilfælde af aflysninger.',
    privacy_clause_4: '{name} videregiver ikke oplysningerne til andre end arrangøren af det pågældende arrangement.',
    liability: 'ANSVARSBEGRÆNSNING',
    liability_clause_1: 'Kontroller venligst bestillingen inden betaling for at sikre dig i mod fejlbestillinger.',
    liability_clause_2: 'Billetten erstattes ikke ved bortkomst, men kan genfremsendes elektronisk eller pr brevpost.',
    liability_clause_3: 'Billetten kan KUN refunderes af arrangøren og KUN i tilfælde af aflysning.',
    liability_clause_4: 'Bestillings og leveringsgebyrer refunderes ikke.',
    liability_clause_5: '{name} har intet ansvar vedrørende arrangørens eventuelle betalingstandsning, konkurs, aflysning eller flytning af dato for afholdelse af et arrangement eller andre reklamationer vedrørende det aktuelle arrangement.',
    liability_clause_6: 'Al henvendelse herom rettes til arrangøren. Kontaktoplysninger forefindes på billetten samt på hjemmesiden, hvor billetten er bestilt.',
    liability_clause_7: 'Moms udgør 20% af billetsummen inklusive billetgebyr, såfremt der er pålagt moms på arrangementet.',
    refund: 'FORTRYDELSESRET',
    refund_clause_1: '{name} fungerer udelukkende som formidler af salg af billetter mellem kunden og den arrangør, der sælger billetterne via {name}\'s onlinesystemer.',
    refund_clause_2: 'Bemærk: I henhold til \"Lov om forbrugeraftaler § 18 stk. 12\" er køb af billetter ikke omfattet fortrydelsesretten.',
    changes: 'AFTALEÆNDRINGER',
    changes_clause_1: '{name} har ret til, på et hvilken som helst tidspunkt, at foretage ændringer i gældende forretningsbetingelser eller priser med 30 dages varsel.',
    law: 'LOVVALG OG VÆRNETING',
    law_clause_1: 'Aftalen er underkastet dansk ret. Enhver uoverensstemmelse mellem parterne afgøres ved Retten i Aarhus.',
  },
  contact: {
    head_title: 'Kontakt',
    title: 'Kontakt os',
    info: 'Info',
    description: 'Hvis du har spørgsmål til arrangementer listet på disse sider under {url} kan du henvende dig til arrangørens kontaktperson på nedenstående telefonnummer eller e-mailadresse.',
    organizer: 'Arrangør',
    contact_person: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-mail',
    email_placeholder: 'E-mail',
    name_placeholder: 'For- og efternavn',
    phone_placeholder: 'Telefonnummer',
    order_number_placeholder: 'Ordrenummer',
    body_placeholder: 'Besked',
    contact_form_info: 'Du kan også kontakte arrangøren via nedenstående kontaktformular.',
    contact_form: 'Kontakt formular',
    submit: 'Send',
    success_message: 'Din besked er sendt!',
    error_message: 'Der opstod en fejl ved afsendelse af din besked. Prøv venligst igen senere.'
  },
  resend_ticket: {
    head_title: 'Gensend billetter',
    title: 'Gensend dine billetter',
    description: 'Har du ikke modtaget dine billetter? Indtast din e-mailadresse herunder, så sender vi dem igen.',
    email_placeholder: 'E-mail',
    submit: 'Send billetter igen',
    success_message: 'Dine billetter er sendt til din e-mailadresse.',
    error_too_soon: 'Du har allerede anmodet om at få dine billetter gensendt for nylig. Vent venligst lidt, og prøv igen.',
    error_invalid_email: 'Vi kunne ikke finde nogen bestillinger tilknyttet denne e-mailadresse.',
    error_generic: 'Der opstod en fejl. Prøv venligst igen senere.',
  }
};

const en: typeof da = {
  common: {
    from: 'From',
    before: 'Before',
    ticket: 'Ticket',
    ticket_plural: 'Tickets',
    edit: 'Edit',
    pcs: 'pcs.',
    discount: 'Discount',
    transaction_fee: 'Transaction fee',
    back: 'Back',
    back_to_overview: 'Back to overview',
    continue: 'Continue',
    fee: 'Ticket fee',
    total: 'Total',
    vat: 'VAT',
    decrease: 'Decrease',
    increase: 'Increase',
    days: 'days',
    show_more: 'Show more',
    show_less: 'Show less',
    see_all: 'See all',
    see_category: 'See category',
    close: 'Close',
    next: 'Next',
    prev: 'Previous',
    soldout: "Soldout",
    few_tickets: "Few tickets left",
    remove: 'Remove',
    cart_emptied_toast: 'The time to complete your order has run out. You have 10 minutes to complete a purchase.'
  },
  checkout: {
    addons: 'Add-ons',
    tickets: 'Tickets',
    choose_seats: 'Choose seats',
    information: 'Customer information',
    choose_tickets: 'Choose tickets',
    redeem: 'Redeem',
    discount_code: 'Discount code',
    redeem_discount_code: 'Redeem discount code',
    redeem_gift_card: 'Redeem gift card',
    vouchercode_removed: '{voucher_code_description} removed',
    gift_card: 'Gift card code',
    type: 'Type',
    download_your_tickets: 'Download your tickets',
    loading_pdf: 'Please wait...',
    download_tickets: 'Download tickets',
    download_tickets_as_pdf: 'Download tickets as PDF',
    your_tickets_are_also_sent_to: 'Your tickets are also sent to:',
    show_info: 'Show info',
    ticket_info: 'Ticket info',
    leave_checkout: 'Leave checkout',
    leave_checkout_header: 'You are about to leave checkout',
    leave_checkout_header_expired: 'The time for checkout has expired',
    leave_checkout_confirmation: 'You will lose your tickets if you leave checkout',
    leave_checkout_confirmation_expired: 'The time to place your order has expired.',
    leave_checkout_continue:
      'You can add tickets to cart and buy more tickets.',
    leave_checkout_leaving_payment: 'If you leave checkout now, your payment will be cancelled and you will have to reorder.',
    stay_in_checkout: 'Stay in checkout',
    stay_in_checkout_cancel: 'Cancel',
    reservation_mismatch: 'The number of tickets could not be reserved. The cart has been updated with the number of tickets that could be reserved.',
    reservation_mismatch_event_max_tickets: 'Maximum {count} {tickets} can be reserved for this event.',
    reservation_mismatch_available: 'Only {count} {tickets} are available for this ticket type.',
    reservation_mismatch_ticket_max_tickets: 'You can only reserve a maximum of {count} {tickets} for this ticket type.',
    reservation_mismatch_ticket_min_tickets: 'You must reserve at least {count} {tickets} for this ticket type.',
    leave: 'Leave',
    payment: 'Payment',
    choose_payment_method: 'Choose payment method',
    countdown: 'left to complete the order',
    receipt: 'Receipt',
    organizer: 'Organizer',
    order_information: 'Order information',
    order_number: 'Order number',
    order_time: 'Order time',
    transaction_id: 'Transaction ID',
    card_number: 'Card number',
    add_to_calendar: 'Add to calendar',
    download_ics: 'Download ICS',
    order_summary: 'Order summary',
    continue_to_payment: 'Continue to payment',
    continue_to_payment_window: 'Continue to payment window',
    cancel_order: 'Cancel order',
    add_to_basket_and_continue: 'Add to cart and shop more',
    add_info_to: 'Add info to {name}',
    order_confirmation_will_be_sent_to:
      'Your order confirmation will be sent here',
    email_placeholder: 'E-mail',
    repeat_email_placeholder: 'Repeat email',
    name_placeholder: 'First and last name',
    address_placeholder: 'Address',
    zip_placeholder: 'Postal code',
    city_placeholder: 'City',
    country_placeholder: 'Country',
    phone_placeholder: 'Phone number',
    terms_label: 'I accept the terms and conditions',
    terms_label_prefix: 'I accept the ',
    terms_label_link: 'terms and conditions',
    terms_label_header: 'Terms and Conditions',
    newsletter_label: 'Yes, sign me up for the {organizer} newsletter',
    seats: 'Seats',
    see_seats: 'See your seats ({selected} / {total} selected)',
    your_seats: 'Your seats',
    extra_tickets_shown: '{count} additional tickets are now shown with the code:',
    extra_ticket_shown: '1 additional ticket is now shown with the code:',
    tickets_recievement_notice:
      'You will receive your ticket by e-mail and must bring it digitally or print it yourself.',
    thanks_for_your_order: 'Thank you for your order',
    ticket_buying_title: 'Ticket purchase info',
    ticket_buying_notice: 'Your tickets are paid. You can download them here.',
    tickets_sent_to_email:
      'We have also sent your tickets to your e-mail address: {email}',
    tickets_entry_notice:
      'The organizer may ask you to show your ticket at the entrance. Please check the ticket for event, date, time, etc. It is important that your ticket is intact and legible when you arrive at the event. A ticket and the unique barcode admit one person. It is illegal to copy tickets.',
    tickets_bank_statement:
      'The ticket purchase will appear as a purchase from Safeticket on your bank statement.',
    tickets_law_notice:
      'Note: According to the "Consumer Contracts Act § 18 section 12", ticket purchases are not subject to the right of withdrawal.',
    tickets_see_terms:
      'See also the ',
    tickets_see_terms_link: 'terms and conditions.',
    questions: 'Questions?',
    questions_can_be_sent_to:
      'Questions can be sent to <a href="mailto:{email}">{email}</a> or <a href="tel:{phone}">{phone}</a>.',
    questions_order_number:
      'Please provide your order number when contacting Safeticket A/S.',
    customfield_group_header_event: '',
    customfield_group_header_tickettype: 'General for registration',
    customfield_group_header_ticket: '{group} Registration',
  },
  event: {
    events: 'Events',
    play_video: 'Play video',
    go_to_slide: 'Go to slide {slide}',
    open_in_google_maps: 'Open in Google Maps',
    location: 'Location',
    find_tickets: 'Find tickets',
    x_tickets_left: '{count} tickets left',
    time: 'Time',
    related_events: 'Related events',
    categories: 'Categories',
    organizer: 'Organizer',
    remarks: 'Remarks',
    photo_video_social_media: 'Photo, video and social media',
    photo_video: 'Photo and Video',
    photo_video_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    social_media: 'Social media',
    social_media_notice:
      'Ut ultricies vestibulum lacus in semper consectetur. Donec non tellus ut enim aliquet lacinia. Aenean ac orci id elit molestudas rhoncus porttitor eget lacus. Quisque a justo tristique, congue dolor et, scelerisque velit. Mauris eget dictum pulvinar. Sed bibendum ut magna ut tincidunt. Praesent pretium ut mi elementum. Phasellus condimentum leo quis erat rhoncus, et lacinia mi dictum.',
    ends_in: 'Ends in',
    starts_in: 'Starts in',
    sold_out: 'Sold out',
    sale_not_started: 'Ticket sale not started yet',
    sale_not_started_with_date: 'Ticket sale starts {date}',
    sale_ended: 'Ticket sale has ended',
  },
  validation: {
    number: 'This field must be a number',
    email: 'Please enter a valid e-mail address',
    emails_must_match: 'E-mail addresses must match',
    phone: 'Please enter a valid phone number',
    cpr: 'Please enter a valid CPR number',
    required: 'This field is required',
    zip: 'Please enter a valid postal code',
    terms: 'You must accept the terms and conditions',
    order_number: 'Please enter a valid order number',
    char_limit: 'Maximum {limit} characters allowed',
    invalid_option: 'Please enter a valid value',
  },
  globals: {
    change_language: 'Change Language',
    categories: 'Categories',
    locations: 'Locations',
    date: 'Date',
    search: 'Search',
    search_placeholder: 'Search for events...',
    cart: 'Cart',
    continue_to_checkout: 'Continue to checkout',
    login: 'Login',
    cart_empty: 'Your cart is empty',
    check_gift_card: 'Check gift card',
    cancel_tickets: 'Cancel tickets',
    transfer_voucher: 'Transfer voucher',
    organizer_login: 'Organizer login',
    ticket_buyer: 'Ticket buyer',
    resend_tickets: 'Lost your ticket?',
    contact: 'Contact',
    terms: 'Terms',
    cookies: 'Cookies',
    cta_title: 'Hosting events? Get a ticketing and registration system',
    cta_unique_selling_point_low_fee: 'Among the lowest fees in Denmark', 
    cta_unique_selling_point_support: 'Free Danish support',
    cta_button_text: 'Learn more',
    choose: 'Choose',
    no_results: 'No results. Try again.',
    see_all_events: 'See all events',
  },
  date: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
  },
  not_found: {
    title: 'Page Not Found',
    message: 'Sorry, the page you are looking for does not exist.',
    back_to_home: 'Back to home',
  },
  terms: {
    head_title: 'Terms',
    organizer: 'Organizer',
    sales_delivery_terms: 'Sales and delivery terms',
    contact_person: 'Contact person',
    phone: 'Phone',
    email: 'E-mail',
    vat: 'CVR',
    applicable_for: 'The following terms apply to',
    hereafter_referred: 'Hereinafter referred to as',
    general: 'GENERAL',
    general_clause_1: 'Any delivery between the parties is based on these general sales and delivery terms.',
    general_clause_2: 'exclusively mediates the sale of tickets between the ticket buyer and the responsible organizer.',
    payment: 'PAYMENT',
    payment_clause_1: 'Payment can be made with Dankort, Visa/Dankort, Visa, MasterCard, and VisaElectron.',
    payment_clause_2: 'Payment must be made by online payment.',
    payment_clause_3: 'Your payment is charged to your payment card when the ticket is dispatched.',
    delivery: 'DELIVERY AND DELAY',
    delivery_clause_1: 'Delivery is either via direct download and e-mail in the form of a PDF file (PrintSelv) immediately after payment, or by choosing postal delivery, sent with PostDanmark as regular mail the next business day. The money is charged to your payment card when the ticket is dispatched.',
    delivery_clause_2: 'In case of loss, replacement tickets can be sent, whereby the original tickets are automatically canceled.',
    privacy: 'PROCESSING OF PERSONAL DATA',
    privacy_clause_1: 'As a customer, you accept that {name} stores the personal data you provide in connection with ticket purchases.',
    privacy_clause_2: '{name} transfers information such as name, address, phone number, and e-mail to the organizer responsible for the event for which you have purchased a ticket.',
    privacy_clause_3: 'This is done to enable the organizer to provide optimal customer service, e.g., in case of cancellations.',
    privacy_clause_4: '{name} does not disclose the information to anyone other than the organizer of the specific event.',
    liability: 'LIMITATION OF LIABILITY',
    liability_clause_1: 'Please check the order before payment to avoid errors.',
    liability_clause_2: 'The ticket is not replaced in case of loss but can be resent electronically or by mail.',
    liability_clause_3: 'The ticket can ONLY be refunded by the organizer and ONLY in case of cancellation.',
    liability_clause_4: 'Booking and delivery fees are non-refundable.',
    liability_clause_5: '{name} has no liability regarding the \'s possible payment default, bankruptcy, cancellation, or rescheduling of the event date or other complaints regarding the current event.',
    liability_clause_6: 'All inquiries in this regard should be directed to the organizer. Contact information can be found on the ticket and the website where the ticket was ordered.',
    liability_clause_7: 'VAT is 20% of the ticket price including the ticket fee, if VAT is applicable to the event.',
    refund: 'RIGHT OF WITHDRAWAL',
    refund_clause_1: '{name} only acts as an intermediary for the sale of tickets between the customer and the organizer selling the tickets via {name}\'s online systems.',
    refund_clause_2: 'Note: According to the "Consumer Contracts Act § 18 section 12", ticket purchases are not subject to the right of withdrawal.',
    changes: 'AMENDMENTS',
    changes_clause_1: '{name} has the right, at any time, to make changes to the applicable business terms or prices with 30 days\' notice.',
    law: 'GOVERNING LAW AND JURISDICTION',
    law_clause_1: 'The agreement is governed by Danish law. Any dispute between the parties is settled by the Court in Aarhus.',
  },
  contact: {
    head_title: 'Contact',
    email_placeholder: 'E-mail',
    name_placeholder: 'First and last name',
    phone_placeholder: 'Phone number',
    order_number_placeholder: 'Order number',
    body_placeholder: 'Message',
    title: 'Contact us',
    info: 'Info',
    description: 'If you have questions about events listed on these pages under {url}, you can contact the organizer\'s contact person at the phone number or email address below.',
    organizer: 'Organizer',
    contact_person: 'Contact person',
    phone: 'Phone',
    email: 'E-mail',
    contact_form_info: 'You can also contact the organizer via the contact form below.',
    contact_form: 'Contact form',
    submit: 'Submit',
    success_message: 'Your message has been sent!',
    error_message: 'There was an error submitting your message. Please try again later.'
  },
  resend_ticket: {
    head_title: 'Resend tickets',
    title: 'Resend your tickets',
    description: 'Did you not receive your tickets? Enter your email address below and we will resend them.',
    email_placeholder: 'E-mail',
    submit: 'Resend tickets',
    success_message: 'Your tickets have been sent to your email address.',
    error_too_soon: 'You have already requested your tickets to be resent recently. Please wait a moment and try again.',
    error_invalid_email: 'We could not find any orders associated with this email address.',
    error_generic: 'An error occurred. Please try again later.',
  }
};

export const messages = {
  en,
  da,
};
